import { render, staticRenderFns } from "./vsTh.vue?vue&type=template&id=621a7973&"
import script from "./vsTh.vue?vue&type=script&lang=js&"
export * from "./vsTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports